<section class="modal-container" aria-label="Privacy Settings Modal" role="dialog">
  <header>
    <h2>
      {{ 'aria-labels.document' | translate }}
      {{ 'aria-labels.settings' | translate }}
    </h2>
    <button (click)="cancel()" aria-label="Close">
      <img src="../../../../../../assets/report_v2/close_big.svg" alt="close" />
    </button>
  </header>
  <section class="document_settings">
    <p>{{ 'individual.upload.translate_document' | translate }}:</p>
    <app-translate></app-translate>
  </section>

  <header>
    <h2 *ngIf="isPrivacyDataLoaded && !isOnIA && (!isSharedSession || currentShareDetails?.share?.accessPermission !== 'view') && !isPrecheckShared">{{ 'app.privacy_settings' | translate }}</h2>
  </header>

  <section class="modal-body" *ngIf="isPrivacyDataLoaded && !isOnIA && (!isSharedSession || currentShareDetails?.share?.accessPermission !== 'view') && !isPrecheckShared">
    <!-- CASE 1: When the the  professor  opens the  student report -->
    <ng-container *ngIf="submissionUserId != this.loggedInUser?.id">
      <section class="modal-action" *ngIf="!(isDocumentInArchive == undefined)">
        <label for="delete_doc_from_arch" [ngClass]="{ disabled: isDocumentInArchive == false }" class="privacy_title">
          {{ 'report.give_student_permission_to_delete_document' | translate }}
          <button [matTooltip]="'new_entries.give_student_permission_document_archives_info' | translate"
            matTooltipPosition="above" matTooltipClass="new_report_tooltip">
            <img src="../../../../../../assets/report_v2/info.svg" alt="" />
          </button>
        </label>
        <input type="checkbox" name="delete_doc_from_arch" id="delete_doc_from_arch"
          [disabled]="isDocumentInArchive == false" [(ngModel)]="permissions.deleteInArchive" />
      </section>
      <section class="modal-action">
        <label for="delete_doc_from_repo" class="privacy_title">
          {{ 'report.give_student_permission_to_delete_everything' | translate }}
          <button [matTooltip]="'new_entries.give_student_permission_to_delete_document_repo_info' | translate"
            matTooltipPosition="above" matTooltipClass="new_report_tooltip">
            <img src="../../../../../../assets/report_v2/info.svg" alt="" />
          </button>
        </label>
        <input type="checkbox" name="delete_doc_from_repo" id="delete_doc_from_repo"
          [(ngModel)]="permissions.deleteEverything" (change)="deleteEverything()" />
      </section>
    </ng-container>

    <!-- CASE 2: When the  professor opens its  own  report or CASE 3: When the  student  opens  its  own report -->
    <div
      *ngIf="((submissionUserId == this.loggedInUser?.id && data.submission.archive && this.loggedInUser.roleId === 10) || (submissionUserId == this.loggedInUser?.id && data.submission.archive && this.loggedInUser.roleId === 9 && this.permissions.deleteInArchive)); else noPermission">
      <span tabindex="0" [attr.aria-label]="'aria-labels.delete_document' | translate" class="privacy_title">
        {{ 'report.delete_document_from_archive' | translate }}
        <button [matTooltip]="'new_entries.delete_document_from_archive_info' | translate" matTooltipPosition="above"
          matTooltipClass="new_report_tooltip">
          <img src="../../../../../../assets/report_v2/info.svg" alt="" />
        </button>
      </span>
      <button class="deleteBtn" (click)="deleteDocument(1)" tabindex="0">{{ 'app.delete' | translate }}</button>
    </div>
    <ng-container *ngIf="loggedInUser.roleId === 9 && !this.permissions.deleteInArchive && !this.permissions.deleteEverything && !data.submission.archive">
      <div #noPermission>You have no permission to delete this document.</div>
    </ng-container>
    <!-- <div *ngIf="permissions?.deleteSources">
        <span tabindex="0" [attr.aria-label]="'aria-labels.delete_similarity_sources' | translate">{{ 'report.delete_similarity_sources' | translate }}</span>
        <button class="deleteBtn"  (click)="deleteDocument(0)" tabindex="0">{{ 'app.delete' | translate }}</button>
      </div> -->
    <div
      *ngIf="submissionUserId == this.loggedInUser?.id && (this.loggedInUser?.roleId !== 9 || this.permissions.deleteEverything)">
      <span class="privacy_title" tabindex="0" [attr.aria-label]="'aria-labels.delete_everything' | translate">
        {{ 'delete.delete_everything' | translate }}
        <button [matTooltip]="'new_entries.delete_document_from_repo_info' | translate" matTooltipPosition="above"
          matTooltipClass="new_report_tooltip">
          <img src="../../../../../../assets/report_v2/info.svg" alt="" />
        </button>
      </span>
      <button class="deleteBtn" (click)="deleteDocument(2)" tabindex="0">{{ 'app.delete' | translate }}</button>
    </div>
  </section>

  <!-- Share Report Section -->
  <section class="share-report-section" *ngIf="canPerformActions() && !isNotStudentPrecheck">
    <header>
      <h2>Share Report</h2>
    </header>

    <!-- Share Method Selection -->
    <div class="share-method-group">
      <div class="radio-options">
        <div class="radio-option">
          <input type="radio" id="share-email" name="shareMethod" value="email" [checked]="shareMethod === 'email'"
            (change)="setShareMethod('email')" />
          <label for="share-email">Share report by email</label>
        </div>

        <div class="radio-option">
          <input type="radio" id="share-link" name="shareMethod" value="link" [checked]="shareMethod === 'link'"
            (change)="setShareMethod('link')" />
          <label for="share-link">Share report by link</label>
        </div>
      </div>

      <button class="cancel-selection" *ngIf="shareMethod !== null" (click)="clearShareMethod()">
        Cancel
      </button>
    </div>

    <!-- Email Sharing Options - Only show when email is selected -->
    <div class="share-options" *ngIf="shareMethod === 'email'">
      <!-- Precheck Disclaimer for Email Sharing -->
      <!-- <div class="precheck-disclaimer" *ngIf="isStudentsDocument">
        <img src="../../../../../../assets/report_v2/info.svg" alt="Info" class="disclaimer-icon" />
        <ng-container *ngIf="isStudentsDocument">
          <div class="disclaimer-content">
            <strong>Note:</strong> Recipients will have view-only access as this is a student submission. Edit permissions are not available for student reports.
          </div>
        </ng-container>
      </div> -->
      <div class="email-access-row">
        <div class="email-input-wrapper">
          <label for="recipient-email">Email address</label>
          <input type="email" id="recipient-email" [(ngModel)]="recipientEmail" (ngModelChange)="onEmailChange()"
            placeholder="Enter email address" [disabled]="isLoadingShare" />
        </div>

        <div class="access-type-wrapper">
          <label for="access-type">Set Access:</label>
          <select id="access-type" [(ngModel)]="accessType" (change)="setAccessType(accessType)"
            [disabled]="isLoadingShare || !isAccessTypeEnabled">
            <option value="one_time">One-time view</option>
            <option value="unlimited">Unlimited access</option>
            <option value="time_based">Time-based access</option>
          </select>
        </div>

        <div class="access-mode-wrapper">
          <label for="access-permission">Set Mode:</label>
          <select id="access-permission" [(ngModel)]="accessPermission" (change)="onAccessPermissionChange()"
            [disabled]="isLoadingShare || !isAccessTypeEnabled">
            <option value="view">View</option>
            <option value="edit">Edit</option>
          </select>
        </div>

        <button class="invite-btn" (click)="sendEmailInvitation()" [disabled]="!isInviteButtonEnabled">
          <span *ngIf="!isLoadingShare">Invite</span>
          <span *ngIf="isLoadingShare">Sending...</span>
        </button>
      </div>

      <!-- Optional message for email sharing -->
      <div class="share-message-wrapper" *ngIf="shareMethod === 'email'">
        <label for="share-message">Message (optional):</label>
        <textarea id="share-message" [(ngModel)]="shareMessage"
          placeholder="Add a personal message for the recipient..." [disabled]="isLoadingShare" rows="3"></textarea>
      </div>

      <!-- Time-based duration picker for email -->
      <div class="time-based-options" *ngIf="shouldShowTimeOptions">
        <div class="inline-time-section">
          <div class="current-time-wrapper">
            <label>Current time:</label>
            <input type="text" [value]="currentTime" disabled class="current-time-input" />
          </div>

          <div class="end-date-wrapper">
            <label for="end-date">Access expires on:</label>
            <input type="datetime-local" id="end-date" [(ngModel)]="timeBasedEndDate" (change)="onEndDateChange()"
              [disabled]="isLoadingShare" />
          </div>

          <div class="duration-preview-wrapper" *ngIf="durationPreview">
            <label>Duration:</label>
            <div class="duration-display" [ngClass]="{'invalid-duration': durationPreview.includes('Invalid')}">
              {{ durationPreview }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Link Sharing Options - Only show when link is selected -->
    <div class="share-options" *ngIf="shareMethod === 'link'">
      <!-- Precheck Disclaimer for Link Sharing -->
      <!-- <div class="precheck-disclaimer" *ngIf="isStudentsDocument">
        <img src="../../../../../../assets/report_v2/info.svg" alt="Info" class="disclaimer-icon" />
        <ng-container *ngIf="isStudentsDocument">
          <div class="disclaimer-content">
            <strong>Note:</strong> Recipients will have view-only access as this is a student submission. Edit permissions are not available for student reports.
          </div>
        </ng-container>
      </div> -->
      <div class="link-access-row">
        <div class="access-type-wrapper">
          <label for="link-access-type">Set Access:</label>
          <select id="link-access-type" [(ngModel)]="accessType" (change)="setAccessType(accessType)"
            [disabled]="isLoadingShare">
            <option value="one_time">One-time view</option>
            <option value="unlimited">Unlimited access</option>
            <option value="time_based">Time-based access</option>
          </select>
        </div>

        <div class="access-mode-wrapper">
          <label for="link-access-permission">Set Mode:</label>
          <select id="link-access-permission" [(ngModel)]="accessPermission" (change)="onAccessPermissionChange()" [disabled]="isLoadingShare">
            <option value="view">View</option>
            <option value="edit">Edit</option>
          </select>
        </div>

        <button class="copy-link-btn" (click)="generateShareLink()" [disabled]="!isCopyLinkButtonEnabled">
          <!-- <img src="../../../../../../assets/report_v2/copy.svg" alt="copy" /> -->
          <span *ngIf="!isLoadingShare">Generate Link</span>
          <span *ngIf="isLoadingShare">Generating...</span>
        </button>
      </div>

      <!-- Generated Link Display -->
      <div class="generated-link-section" *ngIf="generatedShareLink">
        <div class="generated-link-container">
          <label>Report Link:</label>
          <div class="link-display-row">
            <input type="text" [value]="generatedShareLink" readonly class="generated-link-input" />
            <button class="copy-link-action-btn" (click)="copyLinkToClipboard()"
              [title]="linkCopyMessage || 'Copy link to clipboard'">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16 4H18C19.1046 4 20 4.89543 20 6V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V6C4 4.89543 4.89543 4 6 4H8"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <rect x="8" y="2" width="8" height="4" rx="1" ry="1" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <span>{{ linkCopyMessage || 'Copy' }}</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Time-based duration picker for link -->
      <div class="time-based-options" *ngIf="accessType === 'time_based'">
        <div class="inline-time-section">
          <div class="current-time-wrapper">
            <label>Current time:</label>
            <input type="text" [value]="currentTime" disabled class="current-time-input" />
          </div>

          <div class="end-date-wrapper">
            <label for="link-end-date">Access expires on:</label>
            <input type="datetime-local" id="link-end-date" [(ngModel)]="timeBasedEndDate" (change)="onEndDateChange()"
              [disabled]="isLoadingShare" />
          </div>

          <div class="duration-preview-wrapper" *ngIf="durationPreview">
            <label>Duration:</label>
            <div class="duration-display" [ngClass]="{'invalid-duration': durationPreview.includes('Invalid')}">
              {{ durationPreview }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Who has access section -->
    <div class="access-list-section">
      <h3>Who has access?</h3>

      <div class="access-table">
        <div class="access-table-header">
          <span class="email-col">Email</span>
          <span class="access-type-col">Access type</span>
          <span class="mode-col">Mode</span>
          <span class="status-col">Status</span>
          <span class="action-col">Action</span>
        </div>

        <div class="access-table-body" *ngIf="shareAccesses.length > 0">
          <div class="access-row-container" *ngFor="let share of shareAccesses">
            <!-- Main row -->
            <div class="access-row" (click)="toggleRowExpansion(share.id)">
              <span class="email-col">
                <div class="email-with-icon">
                  <span class="email-text">{{ share.email }}</span>
                  <span class="expand-icon" [ngClass]="{'expanded': isRowExpanded(share.id)}">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </span>
                </div>
              </span>
              <span class="access-type-col">
                <select class="access-type-select" [value]="share.accessType" [disabled]="true"
                  (click)="$event.stopPropagation()">
                  <option value="one_time">One-time view</option>
                  <option value="unlimited">Unlimited access</option>
                  <option value="time_based">Time-based access</option>
                </select>
              </span>
              <span class="mode-col">
                <span class="mode-text"
                  [ngClass]="{'mode-edit': share.accessPermission === 'edit', 'mode-view': share.accessPermission === 'view'}">
                  {{ share.accessPermission }}
                </span>
              </span>
              <span class="status-col">
                <span class="status-text" [ngClass]="getStatusClass(share)">
                  {{ getStatusDisplay(share.status) }}
                </span>
              </span>
              <span class="action-col">
                <button class="remove-link" (click)="removeShareAccess(share.id); $event.stopPropagation()"
                  [disabled]="isLoadingShare || share.isRevoked">
                  Remove
                </button>
              </span>
            </div>

            <!-- Expanded details -->
            <div class="expanded-details" *ngIf="isRowExpanded(share.id)">
              <div class="details-content">
                <div class="detail-row">
                  <span class="label">Share Type:</span>
                  <span class="value">{{ getShareTypeDisplayText(share.shareType) }}</span>
                </div>
                <div class="detail-row">
                  <span class="label">Created:</span>
                  <span class="value">{{ formatDate(share.shareCreatedAt) }}</span>
                </div>
                <div class="detail-row">
                  <span class="label">Expires:</span>
                  <span class="value" [ngClass]="{'expired': share.isExpired}">{{ formatDate(share.expiresAt) }}</span>
                </div>
                <div class="detail-row">
                  <span class="label">Access Count:</span>
                  <span class="value">{{ share.accessCount }}</span>
                </div>
                <div class="detail-row">
                  <span class="label">First Access:</span>
                  <span class="value">{{ formatDate(share.firstAccessedAt) }}</span>
                </div>
                <div class="detail-row">
                  <span class="label">Last Access:</span>
                  <span class="value">{{ formatDate(share.lastAccessedAt) }}</span>
                </div>
                <div class="detail-row" *ngIf="share.shareType === 'email_share'">
                  <span class="label">Email Sent:</span>
                  <span class="value">{{ formatDate(share.emailSentAt) }}</span>
                </div>
                <div class="detail-row" *ngIf="share.shareType === 'email_share'">
                  <span class="label">Email Delivered:</span>
                  <span class="value" [ngClass]="{'success': share.emailDelivered, 'error': !share.emailDelivered}">
                    {{ share.emailDelivered ? 'Yes' : 'No' }}
                  </span>
                </div>
                <div class="detail-row">
                  <span class="label">Share ID:</span>
                  <span class="value id-value">{{ share.id }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="no-access-message" *ngIf="shareAccesses.length === 0">
          <span>No one has access to this report yet.</span>
        </div>
      </div>
    </div>
  </section>

  <!-- Recipient View - Show received shares -->
  <section class="shared-report-section" *ngIf="userRole === 'recipient'">
    <header>
      <h2>Shared Document Details</h2>
    </header>

    <div *ngIf="!currentShareDetails" class="no-access-message">
      <div class="empty-state">
        <span>Loading share details...</span>
      </div>
    </div>

    <div *ngIf="currentShareDetails">
      <!-- Your Access Card -->
      <div class="your-access-section">
        <h3>Your Access</h3>
        <div class="access-card">
          <div class="access-card-header">
            <span class="document-title">{{ currentShareDetails.share.submission.title }}</span>
            <span class="status-badge" [ngClass]="'status-' + currentShareDetails.share.status">
              {{ getStatusDisplay(currentShareDetails.share.status) }}
            </span>
          </div>
          <div class="access-card-body">
            <div class="detail-item">
              <span class="label">Shared by:</span>
              <span class="value">{{ currentShareDetails.share.sharedBy.name }} ({{
                currentShareDetails.share.sharedBy.email
              }})</span>
            </div>
            <div class="detail-item">
              <span class="label">Access Type:</span>
              <span class="value">
                {{ getAccessTypeDisplay(currentShareDetails.share.accessType) }}
              </span>
            </div>
            <div class="detail-item">
              <span class="label">Access Mode:</span>
              <span class="value">
                <span class="mode-text" [ngClass]="
                    'mode-' + currentShareDetails.share.accessPermission
                  ">
                  {{ currentShareDetails.share.accessPermission }} access
                </span>
              </span>
            </div>
            <div class="detail-item">
              <span class="label">Shared on:</span>
              <span class="value">{{
                formatDate(currentShareDetails.share.shareCreatedAt)
              }}</span>
            </div>
            <div class="detail-item" *ngIf="
                currentShareDetails.share.accessType === 'time_based' &&
                currentShareDetails.share.expiresAt
              ">
              <span class="label">Expires on:</span>
              <span class="value" [ngClass]="{
                  expired: currentShareDetails.share.status === 'expired'
                }">{{ formatDate(currentShareDetails.share.expiresAt) }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Others With Access Table -->
      <!-- <div class="others-with-access-section" *ngIf="
          currentShareDetails.othersWithAccess &&
          currentShareDetails.othersWithAccess.total > 0
        ">
        <div class="others-header-with-toggle">
          <h3>
            Who Else Has Access ({{
            currentShareDetails.othersWithAccess.total
            }})
          </h3>
          <button class="toggle-button" (click)="toggleOthersTable()"
                  [attr.aria-expanded]="isOthersTableExpanded"
                  aria-label="Toggle others with access table">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                 [ngClass]="{'expanded': isOthersTableExpanded}">
              <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
        </div>
        <div class="others-table" *ngIf="isOthersTableExpanded">
          <div class="others-table-header">
            <span>Recipient</span>
            <span>Access Type</span>
            <span>Access Mode</span>
            <span>Shared On</span>
          </div>
          <div class="others-table-body">
            <div class="others-row" *ngFor="let other of othersWithAccess">
              <div>
                <span class="recipient-info">
                  {{ other.recipientInfo }}
                  <span class="share-type-badge" [ngClass]="'badge-' + other.shareType">
                    {{ getShareTypeDisplayText(other.shareType) }}
                  </span>
                </span>
              </div>

              <div>
                <span class="access-info">
                  {{ getAccessTypeDisplay(other.accessType) }}
                </span>
              </div>

              <div>
                <span class="access-info">
                  <span class="mode-text" [ngClass]="'mode-' + other.accessPermission">
                    {{ other.accessPermission }}
                  </span>
                </span>
              </div>

              <div>
                <span class="date-info">{{
                  formatDate(other.shareCreatedAt)
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </section>

  <section class="modal-btns" *ngIf="
      submissionUserId !== this.loggedInUser?.id && canPerformActions()
    ">
    <button class="submit-btn" (click)="submit()">
      {{ 'general.submit' | translate }}
    </button>
    <button class="cancel-btn" (click)="cancel()">
      {{ 'general.cancel' | translate }}
    </button>
  </section>
</section>
